import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";

const MasterVerify = () => {
  const { user, isAuthLoading } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthLoading) return;
    if (!user || user.info.type !== "master") {
      navigate("/admin/login");
    }
  }, [user, isAuthLoading, navigate]);

  return null;
};

export default MasterVerify;
